import api from "./api";

class ProductService {
  getCategories() {
    return api.get(`v1/api/products/categories`)
  }

  getSubCategories(id) {
    return api.get(`v1/api/products/categories/${id}/subCategories`)
  }

  registerProduct(product) {
    return api.post(`v1/api/users/members/${product.memberId}/products`, product)
  }

  updateProduct(product) {
    return api.put(`v1/api/users/members/products/${product.id}`, product)
  }
  
  deleteProduct(id) {
    return api.delete(`v1/api/users/members/products/${id}`)
  }

  getMemberProducts(){
    return api.get(`v1/api/users/members/products`)
  }
}

export default new ProductService();
